/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { ExperienceLevel, ExperienceType } from '../types/utils';

export class Experience {
	level: ExperienceLevel = ExperienceLevel.NONE

	transactionsPerYear?: number

	type: ExperienceType = ExperienceType.STOCKS

	volumePerYear?: number
}